import React from 'react';
// import logo from './logo.svg';
import './App.css';

// auth provider
import { JWTProvider as AuthProvider } from "./context/JWTProvider";

import router from './routes';
import { RouterProvider } from "react-router-dom";
import { Suspense } from "react";
import Snackbar from "./../src/ui-components/Snackbar/index"


const App: React.FC = () => {
  return (
    <AuthProvider>
      <Suspense fallback={<div className="loader">Loading...</div>}>
        <RouterProvider router={router} />
      </Suspense>
      <Snackbar />
    </AuthProvider>
  );
};

export default App;

